import { render, staticRenderFns } from "./ImpactCard.vue?vue&type=template&id=571b6ef6&scoped=true&"
import script from "./ImpactCard.vue?vue&type=script&lang=js&"
export * from "./ImpactCard.vue?vue&type=script&lang=js&"
import style0 from "./ImpactCard.vue?vue&type=style&index=0&id=571b6ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b6ef6",
  null
  
)

export default component.exports